import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmCheck2IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmCheck2Icon = ({ className, ...props }: EmCheck2IconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_518_36061)">
      <path
        d="M6.19083 21.3073C6.07052 21.3039 5.94849 21.2936 5.82989 21.273C5.08568 21.1406 4.4738 20.613 4.23146 19.898L0.793956 9.58546C0.433019 8.50265 1.01739 7.33389 2.10021 6.97296C3.18302 6.61202 4.35177 7.19639 4.71271 8.27921L6.94708 14.9823L17.6377 1.47296C18.3441 0.57577 19.6452 0.422802 20.5424 1.12921C21.4396 1.83561 21.5926 3.13671 20.8861 4.0339L7.82364 20.5339C7.42146 21.022 6.82333 21.3056 6.19083 21.3073Z"
        fill="#7CB342"
      />
      <path
        d="M12.9198 10.1252C13.1759 9.91203 18.0709 4.07172 18.0709 4.07172C18.0709 4.07172 18.48 3.63688 18.1328 3.25531C17.8063 2.90641 17.38 3.135 17.1755 3.36188C16.9709 3.58875 12.5538 8.79656 12.3716 9.05438C12.1928 9.34485 12.1877 9.70922 12.3561 10.0048C12.5177 10.2661 12.7428 10.2798 12.9198 10.1252Z"
        fill="white"
        opacity="0.35"
      />
      <path
        d="M18.6398 2.77234C18.9531 2.77234 19.207 2.51841 19.207 2.20516C19.207 1.89191 18.9531 1.63797 18.6398 1.63797C18.3266 1.63797 18.0726 1.89191 18.0726 2.20516C18.0726 2.51841 18.3266 2.77234 18.6398 2.77234Z"
        fill="white"
        opacity="0.35"
      />
      <path
        d="M2.18792 11.2561C2.30307 11.2544 2.27901 10.6098 2.57979 9.99281C2.7912 9.55624 3.06448 9.33624 3.06276 9.09218C3.06104 8.84812 2.73276 7.65874 2.48698 7.73781C2.14495 7.84609 1.70839 8.28609 1.61042 8.97187C1.45745 10.0512 1.97651 11.2595 2.18792 11.2561Z"
        fill="white"
        opacity="0.35"
      />
    </g>
    <defs>
      <clipPath id="clip0_518_36061">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmCheck2Icon;
